import { LinkPropertiesType } from "@website/ui/link/link.types";
import omit from "lodash-es/omit";
import { Url } from "next/dist/shared/lib/router/router";
import { BaseSyntheticEvent, MouseEvent } from "react";

export const useLink = (properties: LinkPropertiesType) => {
  const { disabled, href, onClick, itemScope } = properties;

  const handleClick = (event: BaseSyntheticEvent) => {
    if (!disabled)
      return onClick?.(event as MouseEvent<HTMLAnchorElement, MouseEvent>);
    event.preventDefault();
  };

  return {
    rootProperties: {
      ...omit(properties, "children", "className", "color", "disabled"),
      onClick: handleClick,
      role: "link",
      href: (href ?? "") as Url,
      ...(disabled ? { "aria-disabled": true } : { tabIndex: 0 }),
      ...(itemScope && { itemScope: true })
    }
  };
};
